import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const MoveBuyerSchema = z.object({
    id: z.string().regex(/^[0-9a-f]{24}$/i),
    seller: z.string().regex(/^[0-9a-f]{24}$/i),
    tenant: z.string(),
    tenantId: z.string().optional(),
});

export class MoveBuyerDto extends FromSchema(MoveBuyerSchema) {
    tenant: string;
    seller: string;
    id: string;
    tenantId?: string;
}
